
import React, { useState, useEffect } from "react";
import { Icon } from '@iconify/react';
import clearIcon from '@iconify-icons/mdi/clear-outline';
import carIcon from '@iconify-icons/mdi/car-side';
import '../../../../src/assets/Styles/MapControlDispatchCSS/MapControlDispatch.css'

const Tags = ({tagsList, onTagDelete, onTagClick}) => {
  
  const [tags, setTags] = useState([]);
  useEffect(() => {
    if (Array.isArray(tagsList)) {
      setTags(tagsList);
    }
  }, [tagsList]);


  const [search, setSearch] = useState("");

  const removeTag = (index) => {
    setTags(tags?.filter((_, i) => i !== index));
  };

  const clearAll = () => {
    tags.forEach(tag => {
      onTagDelete(tag); // Trigger delete for each tag individually
    });
    setTags([]);
  };

  const filteredTags = tags?.filter(tag =>
    tag.ConfirmationNo.toLowerCase().includes(search.toLowerCase())
  );

  

  return (
    <div className="tripList-overlay" style={styles.container}>
      <input
        type="text"
        placeholder="Search..."
        style={styles.search}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {/* <div style={styles.tagList}>
        {filteredTags?.map((tag, index) => (
          
          <div key={index} style={styles.tag}>
            {
              tag.vehiclePlotted &&
              <Icon icon={carIcon} width="15" height="15" color="darkslategray"/>
            }
            <button onClick={() => onTagDelete(tag)} style={styles.closeButton}>×</button>
            <label style={{ ...styles.tagLabel, fontSize: "10px" }}>
              {tag.ConfirmationNo}
            </label>
            {tag?.Route && (
              <label
                style={{
                  backgroundColor: 'lightgreen',
                  color: 'black',
                  padding: '2px 5px',
                  marginLeft: '5px',
                  fontSize: '10px',
                  fontWeight: 'bold',
                }}>R</label>
            )}
          </div>
        ))}
      </div> */}

    <div style={styles.tagList}>
      {filteredTags?.map((tag, index) => (
        <div
          key={index}
          style={{
            ...styles.tag,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
          }}
          title="Highlight this trip on map"
          onClick={() => onTagClick(tag)} // 🔁 trigger parent callback
        >
          {/*tag.vehiclePlotted*/index == 0 && (
            <Icon icon={carIcon} width="15" height="15" color="white" title="Vehicle is plotted for this Trip"/>
          )}

          <button
            onClick={(e) => {
              e.stopPropagation(); // prevent tag click from firing
              onTagDelete(tag);
            }}
            title="Remove This Trip"
            style={styles.closeButton}
          >
            ×
          </button>

          <label style={{ ...styles.tagLabel, fontSize: "10px" }} title={tag.ConfirmationNo}>
            {tag.ConfirmationNo}
          </label>

          {tag?.Route && (
            <label
              style={{
                backgroundColor: 'lightgreen',
                color: 'black',
                padding: '2px 5px',
                fontSize: '10px',
                fontWeight: 'bold',
              }}
              title="Routed Trip"
            >
              R
            </label>
          )}
        </div>
      ))}
    </div>


      { <button

        title="Warning: This will deselect and remove the items."
        onClick={clearAll}
        disabled={tags.length === 0}
        style={{
          ...styles.mainCloseButton,
          opacity: tags.length === 0 ? 0.5 : 1,
          cursor: tags.length === 0 ? "not-allowed" : "pointer"
        }}
      >
        X
        {/* <Icon icon={clearIcon} width="16" height="16" /> */}
      </button> }
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    background: "#ffffffa8",
    padding: "10px",
   // width: "24%", // or fixed width like "60px"
    // height: "100vh",
    // height: "auto",
    // minHeight: "53%",
    boxSizing: "border-box",
    overflowY: "scroll",
    scrollbarWidth: "none",           // For Firefox
    msOverflowStyle: "none",
  },
  search: {
    marginBottom: "10px",
    padding: "4px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "12px",
  },
  tagList: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    flexGrow: 1,
    overflowY: "auto",
    scrollbarWidth: "none",      // Firefox
    msOverflowStyle: "none"
  },
  tag: {
    display: "flex",
    alignItems: "center",
    background: "#444444",
    // borderRadius: "12px",
    padding: "2px 6px",
    height: "22px",
    whiteSpace: "nowrap"
  },
  closeButton: {
    background: "transparent",
    border: "none",
    marginRight: "0px",
    cursor: "pointer",
    fontWeight: "bold",
    color: "white"
  },
  mainCloseButton: {
    marginTop: "9px",
    background: "coral",
    color: "white",
    border: "none",
    borderRadius: "4px",
    opacity: "1",
    cursor: "pointer"
  },
  tagLabel: {
    cursor: "default",
    userSelect: "none",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    color: "white"
  }
};

export default Tags;
